<div class="main-container">
  <h2 class="page-header">Encryption Secret</h2>

    <!-- <div class="card secret-card"> -->
    <div class="secret-row secret-card">
      <img src="assets/icons/enc-shield.svg" alt="Shield" class="secret-icon">

      <div class="secret-item">
        <span class="secret-label">AES Key</span>
        <div class="secret-value-wrap">
          <span class="secret-value">{{ aesKey }}</span>
          <button class="secret-copy-btn" type="button" (click)="copySecret(aesKey, 'aes')" title="Copy AES Key">
            <img *ngIf="copiedKey !== 'aes'" src="assets/icons/copy.svg" alt="Copy">
            <img *ngIf="copiedKey === 'aes'" src="assets/icons/tick.svg" alt="Copied">
          </button>
        </div>
      </div>

      <div class="secret-item">
        <span class="secret-label">Salt Secret</span>
        <div class="secret-value-wrap">
          <span class="secret-value">{{ saltSecret }}</span>
        </div>
      </div>

      <div class="secret-badge active">Active</div>
    </div>
  <!-- </div> -->
</div>